export const addBlId = (data) => async (dispatch) => {
  dispatch({
    type: 'ADD_BUSINESS_ID',
    payload: data
  });
};
